import { extend } from 'flarum/common/extend';
import IndexSidebar from 'flarum/forum/components/IndexSidebar';
import SpeciesSearchWidget from './components/SpeciesSearchWidget';
export default function addSpeciesSearch() {
  extend(IndexSidebar.prototype, 'items', function (items) {
    // Highest priority so it renders above core's "New discussion" button
    // and tag nav - it's meant to sit at the very top of the homepage's
    // right column.
    items.add('champis-species-search', m(SpeciesSearchWidget, null), 200);
  });
}